import { ReduxAction } from '../../types/common'
import {
  FILTER_AMOUNT_DOWN,
  FILTER_AMOUNT_UP,
  FILTER_CLIENT_BY_INSTRUMENT_NAME,
  FILTER_CLIENT_NAME,
  FILTER_CURRENCY_NAME,
  FILTER_INSTRUMENT_NAME,
  FILTER_MARKET_NAME,
  FILTER_PORTFOLIO_DETAIL,
  ORDER_CLIENTS,
  SORT_ORDERS,
  FILTER_ORDER_TYPE,
  FILTER_SEARCH_ALL,
  FILTER_DATE_FROM,
  FILTER_DATE_TO,
  TRADER_DIARY_TABLE,
  FILTER_ROLE,
  FILTER_CLIENT_INVESTMENT_HORIZONTE,
  FILTER_CLIENT_RISK_PROFILE,
  FILTER_CLIENT_SKILL_EXPERIENCE,
  FILTER_CLIENT_PREFERENCE,
  FILTER_CLIENT_LOSS_ABILITY,
  FILTER_CLIENT_SUITABILITY,
  FILTER_INSTRUMENT_ISIN,
  FILTER_INSTRUMENT_ASSET_CLASS,
  FILTER_INSTRUMENT_CURRENCY,
  FILTER_INSTRUMENT_TICKER,
  FILTER_INSTRUMENT_CATEGORY,
  FILTER_INSTRUMENT_EXPERIENCE,
  FILTER_INSTRUMENT_PREFERENCE,
  FILTER_INSTRUMENT_LOSS_ABILITY,
  FILTER_INSTRUMENT_RISK,
  FILTER_INSTRUMENT_HORIZONTE,
} from '../actionTypes'

export enum ClientSortOptions {
  Az,
  Za,
  AmountUp,
  AmountDown,
  BalanceUp,
  BalanceDown,
  LtvUp,
  LtvDown,
  DebtUp,
  DebtDown,
}

export enum OrdersByStateOptions {
  New,
  Open,
  Partial,
  Settled,
  Rejected,
  Closed,
  All,
}

export enum TraderDiaryByStateOptions {
  Received,
  Settled,
  PartialSettled,
  Canceled,
  All,
}

export interface FiltersState {
  sortOrdersBy: OrdersByStateOptions
  sortTraderDiaryBy: TraderDiaryByStateOptions
  searchedClientName: string
  searchedRole: string,
  sortBy: ClientSortOptions
  portfolioDetail: {
    class: boolean
    instrumentType: boolean
    currency: boolean
  }
  searchedAll: boolean
  searchedInstrumentName: string
  searchedMarketName: string
  searchedAmountUp: string
  searchedAmountDown: string | number
  searchedClientByInstrumentName: string
  searchedCurrencyName: string
  searchedOrderType: string
  searchedDateFrom: Date
  searchedDateTo: Date
  searchedInvestmentHorizonte: string
  searchedRiskProfile: string
  searchedSkillAndExperience: string
  searchedPreference: string
  searchedLossAbility: string
  searchedSuitability: string
  searchedInstrumentIsin: string
  searchedInstrumentAssetClass: string
  searchedInstrumentCurrency: string
  searchedInstrumentTicker: string
  searchedInstrumentCategory: string
  searchedInstrumentExperience: string
  searchedInstrumentPreference: string
  searchedInstrumentLossAbility: string
  searchedInstrumentRisk: string
  searchedInstrumentHorizonte: string
}

const INITIAL_STATE: FiltersState = {
  sortOrdersBy: OrdersByStateOptions.All,
  sortTraderDiaryBy: TraderDiaryByStateOptions.All,
  searchedClientName: '',
  searchedRole: 'SELECT_ROLE_EMPTY',
  sortBy: ClientSortOptions.Az,
  portfolioDetail: {
    class: false,
    instrumentType: true,
    currency: false,
  },
  searchedAll: false,
  searchedInstrumentName: '',
  searchedMarketName: '',
  searchedAmountUp: '',
  searchedAmountDown: '',
  searchedClientByInstrumentName: '',
  searchedCurrencyName: '',
  searchedOrderType: '',
  searchedDateFrom: new Date(new Date().setDate(new Date().getDate() - 7)),
  searchedDateTo: new Date(new Date().setDate(new Date().getDate() + 1)),
  searchedInvestmentHorizonte: '',
  searchedRiskProfile: '',
  searchedSkillAndExperience: '',
  searchedPreference: '',
  searchedLossAbility: '',
  searchedSuitability: '',
  searchedInstrumentIsin: '',
  searchedInstrumentAssetClass: '',
  searchedInstrumentCurrency: '',
  searchedInstrumentTicker: '',
  searchedInstrumentCategory: '',
  searchedInstrumentExperience: '',
  searchedInstrumentPreference: '',
  searchedInstrumentLossAbility: '',
  searchedInstrumentRisk: '',
  searchedInstrumentHorizonte: '',
}

export const filters = (state: FiltersState = INITIAL_STATE, action: ReduxAction) => {
  switch (action.type) {
    case FILTER_CLIENT_NAME:
      return {
        ...state,
        searchedClientName: action.payload,
      }
    case FILTER_ROLE:
      return {
        ...state,
        searchedRole: action.payload,
      }
    case FILTER_DATE_FROM:
      return {
        ...state,
        searchedDateFrom: action.payload,
      }
    case FILTER_DATE_TO:
      return {
        ...state,
        searchedDateTo: action.payload,
      }
    case ORDER_CLIENTS:
      return {
        ...state,
        sortBy: action.payload,
      }
    case FILTER_PORTFOLIO_DETAIL:
      const { name, value } = action.payload
      return {
        ...state,
        portfolioDetail: {
          class: false,
          instrumentType: false,
          currency: false,
          [name]: value,
        },
      }
    case FILTER_SEARCH_ALL:
      return {
        ...state,
        searchedAll: action.payload,
      }
    case FILTER_INSTRUMENT_NAME:
      return {
        ...state,
        searchedInstrumentName: action.payload,
      }
    case FILTER_MARKET_NAME:
      return {
        ...state,
        searchedMarketName: action.payload,
      }
    case FILTER_AMOUNT_UP:
      return {
        ...state,
        searchedAmountUp: action.payload,
      }
    case FILTER_AMOUNT_DOWN:
      return {
        ...state,
        searchedAmountDown: action.payload,
      }
    case SORT_ORDERS:
      return {
        ...state,
        sortOrdersBy: action.payload,
      }
    case TRADER_DIARY_TABLE:
      return {
        ...state, 
        sortTraderDiaryBy: action.payload,
      }
    case FILTER_CLIENT_BY_INSTRUMENT_NAME:
      return {
        ...state,
        searchedClientByInstrumentName: action.payload,
      }
    case FILTER_CURRENCY_NAME:
      return {
        ...state,
        searchedCurrencyName: action.payload,
      }
    case FILTER_ORDER_TYPE:
      return {
        ...state,
        searchedOrderType: action.payload,
      }
    case FILTER_CLIENT_INVESTMENT_HORIZONTE:
      return {
        ...state,
        searchedInvestmentHorizonte: action.payload,
      }
    case FILTER_CLIENT_RISK_PROFILE:
      return {
        ...state,
        searchedRiskProfile: action.payload,
      }
    case FILTER_CLIENT_SKILL_EXPERIENCE:
      return {
        ...state,
        searchedSkillAndExperience: action.payload,
      }
    case FILTER_CLIENT_PREFERENCE:
      return {
        ...state,
        searchedPreference: action.payload,
      }
    case FILTER_CLIENT_LOSS_ABILITY:
      return {
        ...state,
        searchedLossAbility: action.payload,
      }
    case FILTER_CLIENT_SUITABILITY:
      return {
        ...state,
        searchedSuitability: action.payload,
      }
    case FILTER_INSTRUMENT_ISIN:
      return {
        ...state,
        searchedInstrumentIsin: action.payload,
      }
    case FILTER_INSTRUMENT_ASSET_CLASS:
      return {
        ...state,
        searchedInstrumentAssetClass: action.payload,
      }
    case FILTER_INSTRUMENT_CURRENCY:
      return {
        ...state,
        searchedInstrumentCurrency: action.payload,
      }
    case FILTER_INSTRUMENT_TICKER:
      return {
        ...state,
        searchedInstrumentTicker: action.payload,
      }
    case FILTER_INSTRUMENT_CATEGORY:
      return {
        ...state,
        searchedInstrumentCategory: action.payload,
      }
    case FILTER_INSTRUMENT_EXPERIENCE:
      return {
        ...state,
        searchedInstrumentExperience: action.payload,
      }
    case FILTER_INSTRUMENT_PREFERENCE:
      return {
        ...state,
        searchedInstrumentPreference: action.payload,
      }
    case FILTER_INSTRUMENT_LOSS_ABILITY:
      return {
        ...state,
        searchedInstrumentLossAbility: action.payload,
      }
    case FILTER_INSTRUMENT_RISK:
      return {
        ...state,
        searchedInstrumentRisk: action.payload,
      }
    case FILTER_INSTRUMENT_HORIZONTE:
      return {
        ...state,
        searchedInstrumentHorizonte: action.payload,
      }
    default:
      return state
  }
}
